import direDireDocks from '../media/music/dire_dire_docks_-_super_mario_64_music_extended-cut sound reduced.mp3';
import odelia from '../media/music/Dragonica OST - Odelia 2 sound reduced.mp3';
import youBeatTheBoss from '../media/music/dragonica_ost_-_you_beat_the_boss sound reduced.mp3';
import turnaboutSisters from '../media/music/phoenix_wright_ace_attorney_ost_-_ema_skye_~_turnabout_sisters_theme_2005 sound reduced.mp3';
import dontHuntTheFairy from '../media/music/seiken_densetsu_3_soundtrack___18__dont_hunt_the_fairy sound reduced.mp3';
import closedGarden from '../media/music/seiken_densetsu_3_soundtrack___33___closed_garden sound reduced.mp3';
import coral from '../media/music/trickster_soundtrack_-_coral sound reduced.mp3';

// Background tracks previously used in quizzes. hand-raised-effect.mp3 lives in the same
// folder but is the classroom sound effect, so it is deliberately not listed.
export const MUSIC_TRACKS = [direDireDocks, odelia, youBeatTheBoss, turnaboutSisters, dontHuntTheFairy, closedGarden, coral];

export const getRandomMusicFile = (random = Math.random) => MUSIC_TRACKS[Math.floor(random() * MUSIC_TRACKS.length)];
